import { CheckWhiteIcon } from "../../assets/Icons/CheckWhiteIcon";
import { CircleStyled } from "../../styles/StageProgressBar";

interface ICircle {
  stage: number;
  currentStage: number;
  text: string;
  index: number;
}

export const Circle = ({ stage, currentStage, index }: ICircle) => {
  return (
    <CircleStyled>
      <div className={`circle ${(stage <= currentStage) ? "active" : (stage > currentStage && "nextCircles")}`}>
        {stage === currentStage ? <CheckWhiteIcon /> : `${index}`}
      </div>
    </CircleStyled>
  );
};
